export const prepareGetQuery = (filter: Record<string, unknown>) => {
  const keys = Object.keys(filter);
  const filterValues = keys
    .filter((key) => !!filter[key] || filter[key] === 0)
    .map((key) => {
      if (typeof filter[key] === "object" && filter[key] !== null) {
        const entityObject: any = filter[key];
        let queryString: any = [];
        if (Array.isArray(entityObject)) {
          for (const value of entityObject) {
            queryString.push(`${key}[]=${value}`);
          }
        } else {
          for (const prop in entityObject) {
            queryString.push(`${key}[${prop}]=${entityObject[prop]}`);
          }
        }

        return queryString.join("&");
      }
      return `${key}=${filter[key]}`;
    });

  const behind = filterValues.join("&");

  if (behind) return `?${behind}`;

  return "";
};
